<template>
  <div class="producto-final-card card mb-3 shadow-sm">
    <!-- CABECERA -->
    <div class="card-header bg-bulk-light text-bulk-dark d-flex justify-content-between align-items-start flex-wrap border-bottom">
      <div>
        <h6 class="mb-1">{{ producto.tipo_producto || 'Sin tipo' }}</h6>
        <div class="small">
          Código:
          <span class="badge bg-light text-bulk-dark">{{ producto.codigo }}</span>
          <button class="btn btn-sm btn-icon" @click="copiar(producto.codigo)" title="Copiar código">
            <font-awesome-icon icon="copy" />
          </button>
        </div>
      </div>

      <div class="dropdown text-end ms-auto">
        <button class="btn btn-sm btn-light" type="button" data-bs-toggle="dropdown">
          <font-awesome-icon icon="ellipsis-v" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><a class="dropdown-item" @click.prevent="$emit('editar', producto)">Editar</a></li>
          <li><a class="dropdown-item" @click.prevent="abrirTrazabilidad">Trazabilidad</a></li>
          <li><a class="dropdown-item" @click.prevent="$emit('ajustar', producto)">Ajustar</a></li>
          <li><a class="dropdown-item" @click.prevent="$emit('procesar', producto)">Envasar</a></li>
          <li><a class="dropdown-item" @click.prevent="mostrarDetalles = !mostrarDetalles">
            {{ mostrarDetalles ? 'Ocultar Detalles' : 'Ver Detalles' }}
          </a></li>
        </ul>
      </div>
    </div>

    <!-- CUERPO -->
    <div class="card-body pt-3 small">
      <div><strong>Materia Prima:</strong> {{ producto.materia_prima?.codigo || '-' }}
        <button v-if="producto.materia_prima" class="btn btn-sm btn-icon" @click="copiar(producto.materia_prima.codigo)">
          <font-awesome-icon icon="copy" />
        </button>
      </div>

      <div><strong>Cantidad inicial:</strong> {{ producto.cantidad }} {{ producto.unidad_medida }}</div>

      <div>
        <strong>Stock disponible:</strong>
        <span :class="{'text-danger': producto.stockDisponible < 0, 'text-success': producto.stockDisponible >= 0}">
          {{ producto.stockDisponible }} {{ producto.unidad_medida }}
        </span>
      </div>

      <div v-if="mostrarDetalles" class="detalles mt-3 bg-light p-2 rounded">
        <div>Fecha Producción: {{ formatoFecha(producto.fecha_produccion) }}</div>
        <div>Fecha Vencimiento: {{ formatoFecha(producto.fecha_vencimiento) }}</div>
        <div>Observaciones: {{ producto.observaciones || '-' }}</div>
      </div>
    </div>

    <!-- MODAL TRAZABILIDAD -->
    <div v-if="verArbol" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Trazabilidad - {{ producto.codigo }}</h5>
            <button type="button" class="btn-close" @click="verArbol = false"></button>
          </div>
          <div class="modal-body p-0">
            <TrazabilidadBuscador :codigo-inicial="producto.codigo" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="verArbol = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrazabilidadBuscador from '../Trazabilidad/TrazabilidadBuscador.vue';

export default {
  name: 'ProductoFinalGestionCard',
  components: { FontAwesomeIcon, TrazabilidadBuscador },
  props: {
    producto: { type: Object, required: true }
  },
  data() {
    return {
      mostrarDetalles: false,
      verArbol: false
    };
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return '-';
      return new Date(fecha).toLocaleDateString();
    },
    copiar(texto) {
      navigator.clipboard.writeText(texto);
      this.$emit('copiado', texto);
    },
    abrirTrazabilidad() {
      if (this.producto.codigo) this.verArbol = true;
    }
  }
};
</script>





<style scoped>
.producto-final-card {
  border-radius: 0.75rem;
  transition: box-shadow 0.3s ease;
}

.producto-final-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
}

.bg-bulk-light {
  background-color: #f0f5f8;
}

.text-bulk-dark {
  color: #205375;
}

.badge {
  font-size: 0.75rem;
}

.btn-icon {
  background: none;
  border: none;
  padding: 0;
  margin-left: 6px;
  color: #6c757d;
}

.btn-icon:hover {
  color: #000;
}

.detalles {
  font-size: 0.85rem;
}

.text-success {
  font-weight: 600;
}
</style>
